import Swiper from 'swiper/bundle';
import { setSlideOutContainer } from '../util/swiper-utils';

export default {
  init() {

    const sliders = document.querySelectorAll('.product-search-slider');

    if(sliders && sliders.length > 0) {
      sliders.forEach(slider => {
        let spacer = getComputedStyle(slider).getPropertyValue('--spacer-lg');
        spacer = spacer ? parseInt(spacer) : 30;
        new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          autoHeight: false,
          loop: false,
          centeredSlides: true,
          centeredSlidesBounds: true,
          grabCursor: true,
          ///createElements: true,
          on: {
            slideChangeTransitionEnd: setSlideOutContainer,
            setTranslate: setSlideOutContainer,
          },
          breakpoints: {
            992: {
              spaceBetween: spacer,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            1400: {
              spaceBetween: spacer,
              // centeredSlides: false,
              // centeredSlidesBounds: false,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              freeMode: {
                enabled: true,
              },
            },
            1920: {
              spaceBetween: spacer,
              centeredSlides: true,
              centeredSlidesBounds: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              freeMode: {
                enabled: true,
              },
            },
          },
        })
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
